import { GetPermissionTreeData } from "../../pages/securityPermission/GenarateTreeData";
import { signOut } from "../../utils/AuthenticationLibrary";
import BaseDomainService from "./baseDomainServices";

const formField = {
  roleId: ""
}

export default class securityPermissionServices extends BaseDomainService {

  savePermission = this.apiService.securityPermissionServices.addSecurityPermissions;
  getRoles = this.apiService.securityPermissionServices.getRoleListByClientIdAndClientSecret;
  showSecurityPermission = this.apiService.securityPermissionServices.getAllSecurityPermissionsByRoleId;

  formFields = [
    {
      inputType: "select",
      tittle: "Select Roles",
      placeholder: "Select Dropdown",
      fieldName: "roleId",
      options: [],
      optionFieldName: "roleName",
      subRequest: "1",
      className: '',
      validation: [{ type: "require" }]
    }
  ]
  dataItem;

  onGetRoles = () => {
    this.apiService.onAPICall("getRoles", this.getRoles, null, this.onAPIResponse, this.onUpdateState);
  };
  onShowSecurity = (selectedId) => {
    this.apiService.onAPICall("showSecurity", this.showSecurityPermission, selectedId, this.onAPIResponse, this.onUpdateState);
  };
  onSavePermission = (request) => {
    this.apiService.onAPICall("savePermission", this.savePermission, request, this.onAPIResponse, this.onUpdateState);
  };

  constructor() {
    super();
    this.dataItem = { ...formField, CreatedBy: this.authUser ? this.authUser.adminUserId : null };
  }


  onAPIResponse = (key, isSuccess, responseData) => {
    this.onUpdateState({ setIsLoad: false });
    if (!isSuccess) {
      this.onUpdateState({ setIsLoad: false });
      return;
    }
    switch (key) {
      case "savePermission":
        this.apiService.serviceManager.swalServices.Confirm(
          "Security Permissions Updated!", "You will be logged out! Please Log In again",
          "LogOut", "No", false)
          .then(async (confirm) => {
            if (confirm) {
              signOut()
            }
          });
        this.onUpdateState({ "setIsLoad": false });
        break;
      case "getRoles":
        let itemList = responseData;
        if (itemList !== null) {
          const roles = itemList.map(item => ({
            id: item.roleId,
            name: item.roleName,
          }));
          this.onUpdateState({
            setRoleList: roles,
            setIsLoad: false,
          });
        }
        break;
      case "showSecurity":
        let itemData = responseData;
        let data = GetPermissionTreeData(itemData);
        this.onUpdateState({
          setPermissionTreeData: data,
          permissionItem: data,
          setIsLoad: false,
        });
        break;
    }
  };
}

